import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const Topbar = () => {

  // const dropdownRef = useRef(null);
  const [notification, setnotification] = useState([]);

  const seller_id = localStorage.getItem("seller_id");

  const API_URL = "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_notification";

  useEffect(() => {
    if (!seller_id) {
      toast.error("Notification ID missing");
      return;
    }

    fetchnotification();
  }, [seller_id]);

  const fetchnotification = async () => {
  try {
    const response = await axios.post(API_URL, {
      seller_id,
      role: "All_Seller"
    });

    if (response.data.status === "true") {
      setnotification(response.data.data);
    }
  } catch (err) {
    console.error(err);
  }
};


  useEffect(() => {
  const dropdownElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'));
  dropdownElementList.map((dropdownToggleEl) =>
    new window.bootstrap.Dropdown(dropdownToggleEl)
  );
}, []);

const handlelogout = () =>{
  localStorage.removeItem("seller_id");
  localStorage.removeItem("seller");
  window.dispatchEvent(new Event("sellerLoggedIn"))
  window.location.href = "/";
}

  return (
    <div>
      <header className="topbar">
  <div className="container-fluid">
    <div className="navbar-header">
      <div className="d-flex align-items-center">
        {/* Menu Toggle Button */}
        <div className="topbar-item">
          <button type="button" className="button-toggle-menu me-2">
         
              <i className="fa-solid fa-bars fs-24 align-middle"></i>
           
  
          </button>
        </div>
        {/* App Search*/}
        <form className="app-search d-none d-md-block ms-2">
          <div className="position-relative">
            <input
              type="search"
              className="form-control"
              placeholder="Search..."
              autoComplete="off"
              defaultValue=""
            />
            <i className="fa-solid fa-magnifying-glass search-widget-icon"></i>
          </div>
        </form>
      </div>

      <div className="d-flex align-items-center gap-1">
        {/* Notification */}
        <div className="dropdown topbar-item">
          <button
            type="button"
            className="topbar-button position-relative"
            id="page-header-notifications-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i className="fa-regular fa-bell fs-24 align-middle" />
            <span className="position-absolute topbar-badge fs-10 translate-middle badge bg-danger rounded-pill">
              3<span className="visually-hidden">unread messages</span>
            </span>
          </button>
          <div
            className="dropdown-menu py-0 dropdown-lg dropdown-menu-end"
            aria-labelledby="page-header-notifications-dropdown"
          >
            <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
              <div className="row align-items-center">
                <div className="col">
                  <h6 className="m-0 fs-16 fw-semibold"> Notifications</h6>
                </div>
                <div className="col-auto">
                  <a
                    href="javascript: void(0);"
                    className="text-dark text-decoration-underline"
                  >
                    <small>Clear All</small>
                  </a>
                </div>
              </div>
            </div>

            <div data-simplebar="" style={{ maxHeight: 280 }}>
              {/* Item */}
              {notification.length === 0 ? (
          <div className="empty-notification">No Notification</div>
        ) : (
          notification.map((item) => (
              <a
                href="javascript:void(0);"
                key={item.id}
              className={`dropdown-item p-2 border-bottom text-wrap${String(item.is_read) === "0" ? "unread" : ""
                }`}
              >
                <div className="d-flex">
                  <div className="flex-shrink-0">
                  {item.user_image ? (
  <img src={item.user_image} alt="" />
) : (
  <span className="notify-icon">
    {item.type === "payment" && <i className="fa-solid fa-wallet"></i>}
    {item.type === "order" && <i className="fa-solid fa-bag-shopping"></i>}
    {item.type === "offer" && <i className="fa-solid fa-tag"></i>}
    {item.type === "delivery" && <i className="fa-solid fa-truck"></i>}
    {!item.type && <i className="fa-regular fa-bell"></i>}
  </span>
)}

                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0">
                      <span className="fw-semibold">{item.title}</span> <br></br>
                      <span>
                        {item.message}
                      </span>
                    </p>
                  </div>
                </div>
              </a>
              ))
        )}
            </div>
            <div className="text-center py-3 notification-btn">
              <a href="javascript:void(0);" className="btn btn-primary btn-sm">
                View All Notification{" "}
                <i class="fa-solid fa-arrow-right ms-1"></i>
              </a>
            </div>
          </div>
        </div>


        {/* Theme Setting */}
        <div className="topbar-item d-none d-md-flex">
          <button
            type="button"
            className="topbar-button"
            id="theme-settings-btn"
            data-bs-toggle="offcanvas"
            data-bs-target="#theme-settings-offcanvas"
            aria-controls="theme-settings-offcanvas"
          >
            <i className="fa-solid fa-gear fs-24 align-middle" />
          </button>
        </div>

        {/* Activity */}
        <div className="topbar-item d-none d-md-flex">
          <button
            type="button"
            className="topbar-button"
            id="theme-settings-btn"
            data-bs-toggle="offcanvas"
            data-bs-target="#theme-activity-offcanvas"
            aria-controls="theme-settings-offcanvas"
          >
            <i className="fa-regular fa-clock fs-24 align-middle" />
          </button>
        </div>
        {/* User */}
        <div className="dropdown topbar-item">
          <a
            type="button"
            className="topbar-button"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="d-flex align-items-center">
              <img
                className="rounded-circle"
                width={32}
                src="/images/users/avatar-1.jpg"
                alt="avatar-3"
              />
            </span>
          </a>
          <div className="dropdown-menu dropdown-menu-end">
            {/* item*/}
            <h6 className="dropdown-header">Welcome Gaston!</h6>
            <a className="dropdown-item" href="pages-profile.html">
              <i className="bx bx-user-circle text-muted fs-18 align-middle me-1" />
              <span className="align-middle">Profile</span>
            </a>
            <a className="dropdown-item" href="apps-chat.html">
              <i className="bx bx-message-dots text-muted fs-18 align-middle me-1" />
              <span className="align-middle">Messages</span>
            </a>
            <a className="dropdown-item" href="pages-pricing.html">
              <i className="bx bx-wallet text-muted fs-18 align-middle me-1" />
              <span className="align-middle">Pricing</span>
            </a>
            <a className="dropdown-item" href="pages-faqs.html">
              <i className="bx bx-help-circle text-muted fs-18 align-middle me-1" />
              <span className="align-middle">Help</span>
            </a>
            <a className="dropdown-item" href="auth-lock-screen.html">
              <i className="bx bx-lock text-muted fs-18 align-middle me-1" />
              <span className="align-middle">Lock screen</span>
            </a>
            <div className="dropdown-divider my-1" />
            <Link onClick={handlelogout} className="dropdown-item text-danger" href="auth-signin.html">
              <i className="bx bx-log-out fs-18 align-middle me-1 " />
              <span className="align-middle">Logout</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

    </div>
  )
}

export default Topbar
